import { render, staticRenderFns } from "./BreedingMound.vue?vue&type=template&id=3a495eb6&scoped=true&"
import script from "./BreedingMound.vue?vue&type=script&lang=js&"
export * from "./BreedingMound.vue?vue&type=script&lang=js&"
import style0 from "./BreedingMound.vue?vue&type=style&index=0&id=3a495eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a495eb6",
  null
  
)

component.options.__file = "BreedingMound.vue"
export default component.exports